var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_vm.forms.length ? _vm._l(_vm.forms, function (form, index) {
    return _c('div', {
      key: index,
      staticClass: "border p-3 card-sr-information-form mb-3",
      attrs: {
        "id": "form-subcon-".concat(index)
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h5', {
      staticClass: "text-primary mb-2"
    }, [_c('strong', [_vm._v("Sub Contractor")])])]), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "company"
      }
    }, [_vm._v("Company")]), _c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "company"
      },
      model: {
        value: form.subkon_name,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_name", $$v);
        },
        expression: "form.subkon_name"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "pic"
      }
    }, [_vm._v("PIC")]), _c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "pic"
      },
      model: {
        value: form.subkon_pic,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_pic", $$v);
        },
        expression: "form.subkon_pic"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "email"
      }
    }, [_vm._v("Email")]), _c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "email"
      },
      model: {
        value: form.subkon_pic_email,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_pic_email", $$v);
        },
        expression: "form.subkon_pic_email"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "phone"
      }
    }, [_vm._v("Phone")]), _c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "phone"
      },
      model: {
        value: form.subkon_pic_phone,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_pic_phone", $$v);
        },
        expression: "form.subkon_pic_phone"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "cost"
      }
    }, [_vm._v("Est. Cost Sub Contractor")]), _c('b-input-group', {
      attrs: {
        "prepend": "Rp"
      }
    }, [_c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "cost",
        "type": "number"
      },
      model: {
        value: form.subkon_price_deal,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_price_deal", $$v);
        },
        expression: "form.subkon_price_deal"
      }
    })], 1), _c('small', [_vm._v(" " + _vm._s(_vm.formatCurrency(form.subkon_price_deal)))])], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "phone2"
      }
    }, [_vm._v("Phone 2")]), _c('b-form-input', {
      staticClass: "bg-white",
      attrs: {
        "id": "phone2",
        "type": "number"
      },
      model: {
        value: form.phone2,
        callback: function callback($$v) {
          _vm.$set(form, "phone2", $$v);
        },
        expression: "form.phone2"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "6"
      }
    }, [_c('label', {
      attrs: {
        "for": "attachment"
      }
    }, [_vm._v("Sub Contractor Attachment "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-file', {
      staticClass: "mb-2",
      attrs: {
        "multiple": "",
        "required": ""
      },
      on: {
        "input": function input(val) {
          return _vm.handleInputFiles(val, form);
        }
      },
      model: {
        value: form.subkon_file,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_file", $$v);
        },
        expression: "form.subkon_file"
      }
    })], 1), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-row', {
      staticClass: "m-0"
    }, _vm._l(form.filePreview, function (file, idx) {
      return _c('b-col', {
        key: "".concat(index, "-").concat(idx),
        staticClass: "p-0 pr-2 mb-3",
        attrs: {
          "lg": "2"
        }
      }, [_c('AttachmentSR', {
        attrs: {
          "modelId": form.id,
          "modelName": "sr_form_repair_entity",
          "file": file
        },
        on: {
          "delete": function _delete() {
            return _vm.handleDeleteFile(form, idx);
          }
        }
      })], 1);
    }), 1)], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "12"
      }
    }, [_c('label', {
      attrs: {
        "for": "remark"
      }
    }, [_vm._v("Remark")]), _c('b-form-textarea', {
      staticClass: "bg-white",
      attrs: {
        "id": "remark",
        "placeholder": "input remarks...",
        "rows": "3"
      },
      model: {
        value: form.subkon_notes,
        callback: function callback($$v) {
          _vm.$set(form, "subkon_notes", $$v);
        },
        expression: "form.subkon_notes"
      }
    })], 1)], 1)], 1);
  }) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }